import { StabilityReportOutput } from '@eppendorf/vnls-reporting-service-utils';
import { FetchInfiniteQueryOptions, QueryClient } from '@tanstack/react-query';
import { ReactElement } from 'react';

import { STABILITY_REPORTS_BASE_PATH } from '$shared/utils/api-paths';
import { prepopulateInfiniteQueryCache } from '$shared/utils/react-query.utils';

import { ReportHubOverview } from '$features/report-hub/report-hub-overview';
import {
  createInfiniteReportsQuery,
  stabilityReportsQueryKey,
} from '$features/report-hub/report-hub.api';
import {
  getSubscriptionSync,
  isSampleSafetyPlusPlan,
} from '$features/subscription/subscription-api';

export async function reportHubLoader(queryClient: QueryClient): Promise<null> {
  const subscription = await getSubscriptionSync(queryClient);
  if (!isSampleSafetyPlusPlan(subscription)) {
    return null;
  }

  return prepopulateInfiniteQueryCache<StabilityReportOutput[]>(
    queryClient,
    createInfiniteReportsQuery<StabilityReportOutput>(
      STABILITY_REPORTS_BASE_PATH,
      stabilityReportsQueryKey,
    ) as FetchInfiniteQueryOptions<StabilityReportOutput[]>,
  );
}

export function ReportHubPage(): ReactElement {
  return <ReportHubOverview />;
}
